// Издание сборки. `saas` — наш контур на ys/newton.1bitai.ru; `onprem` — установка
// у клиента, которую мы продаём с 03.09.2026 (решение Владимира).
//
// Разница не в настройках, а в составе: на `onprem` нет ни нашего договора, ни нашей
// коммерции. Оферта, согласие на обработку ПДн, реквизиты ООО «Точка роста», витрина,
// тарифы и оплата картой в клиентскую сборку не входят вовсе — платёжного контура
// на on-prem нет, продажи конечному пользователю тоже, значит и оферты, которую он
// принимает, быть не может.
//
// Разбор границы: docs/superpowers/specs/2026-09-03-client-edition-boundary.md
//
// 🔴 Этот модуль решает, ЧТО ПОКАЗЫВАТЬ, и только это. Что попадёт в СБОРКУ, он не
// решает: измерено 04.09.2026 — динамический `import()` внутри ложной ветки выносит
// код из main.js, но чанк всё равно создаётся и лежит в build/static/js. Договор и
// реквизиты уходят из того, что клиент СКАЧИВАЕТ, но остаются в том, что у него
// ЛЕЖИТ. Довести до конца — задача docs/backlog/client-edition-split.md.
export const EDITION = process.env.REACT_APP_EDITION || 'saas';

export const IS_SAAS = EDITION !== 'onprem';
